// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Fetch = require("bs-fetch/src/Fetch.res.js");
var React = require("react");
var Moment = require("moment");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Mode$ReactHooksTemplate = require("./mode.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var SmsMode$ReactHooksTemplate = require("./SmsMode.res.js");
var Campaign$ReactHooksTemplate = require("./campaign.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var EmailMode$ReactHooksTemplate = require("./EmailMode.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");
var AppLinkMode$ReactHooksTemplate = require("./AppLinkMode.res.js");
var EmailFromId$ReactHooksTemplate = require("./emailFromId.res.js");
var SmsLinkMode$ReactHooksTemplate = require("./SmsLinkMode.res.js");
var SmsSenderId$ReactHooksTemplate = require("./smsSenderId.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var SelectBoxNew$ReactHooksTemplate = require("../common/SelectBoxNew.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");
var CampaignModes$ReactHooksTemplate = require("../general_settings/campaignModes.res.js");
var EmailTemplate$ReactHooksTemplate = require("./emailTemplate.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");
var WebsiteLinkMode$ReactHooksTemplate = require("./WebsiteLinkMode.res.js");
var ApiConfiguration$ReactHooksTemplate = require("../general_settings/apiConfiguration.res.js");
var EmailSenderPopUp$ReactHooksTemplate = require("../common/EmailSenderPopUp.res.js");
var TextAreaInputNew$ReactHooksTemplate = require("../common/TextAreaInputNew.res.js");
var WhatsappLinkMode$ReactHooksTemplate = require("./WhatsappLinkMode.res.js");
var AnonymousLinkMode$ReactHooksTemplate = require("./AnonymousLinkMode.res.js");
var ApplicationSetting$ReactHooksTemplate = require("../general_settings/applicationSetting.res.js");
var FollowUpSurveyMode$ReactHooksTemplate = require("./FollowUpSurveyMode.res.js");
var FollowUpSendingRule$ReactHooksTemplate = require("./FollowUpSendingRule.res.js");
var SurveyResponseWindow$ReactHooksTemplate = require("../general_settings/surveyResponseWindow.res.js");
var FollowUpSurveyConditions$ReactHooksTemplate = require("./FollowUpSurveyConditions.res.js");

var initialState_campaign = Campaign$ReactHooksTemplate.empty();

var initialState = {
  campaign: initialState_campaign,
  edited: false,
  sendingFrequencyType: "Hour",
  notification: undefined,
  enabled: false,
  followUpModes: /* [] */0,
  deletedFollowUpModes: /* [] */0,
  availableModes: Campaign$ReactHooksTemplate.availableModes,
  followUpConditions: /* [] */0,
  deletedFollowUpConditions: /* [] */0,
  dataFields: /* [] */0
};

function FollowUpSurvey(props) {
  var campaignId = props.campaignId;
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setEmailTemplates = match$1[1];
  var emailTempaltes = match$1[0];
  var match$2 = React.useState(function (param) {
        return /* [] */0;
      });
  var setEmailFromIds = match$2[1];
  var emailFromIds = match$2[0];
  var match$3 = React.useState(function (param) {
        return /* [] */0;
      });
  var setSenderIds = match$3[1];
  var senderIds = match$3[0];
  var match$4 = React.useState(function (param) {
        return /* [] */0;
      });
  var setWhatsappApiConfigurations = match$4[1];
  var whatsappApiConfigurations = match$4[0];
  var match$5 = React.useState(function (param) {
        return EmailFromId$ReactHooksTemplate.empty();
      });
  var setNewEmailFromId = match$5[1];
  var newEmailFromId = match$5[0];
  var match$6 = React.useState(function (param) {
        return false;
      });
  var setShowEmailPopup = match$6[1];
  var showEmailPopup = match$6[0];
  var validationErrors = function (field) {
    return JsxRuntime.jsx("div", {
                children: $$Array.of_list(Belt_List.mapWithIndex(FormField$ReactHooksTemplate.getValidationError(field), (function (key, error) {
                            return JsxRuntime.jsx("p", {
                                        children: error,
                                        className: "text-red-500 text-xs float-right"
                                      }, String(key));
                          }))),
                className: "my-2"
              });
  };
  var fieldValidation = function (value) {
    if (value === 0) {
      return JsxRuntime.jsx("p", {
                  children: "value must be greater than 0",
                  className: "text-red-500 text-xs mt-1"
                });
    } else {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
  };
  var handleEmailInputChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    var trimmedValue = value.trim();
    Curry._1(setNewEmailFromId, (function (prev) {
            return EmailFromId$ReactHooksTemplate.setFromId(prev, trimmedValue);
          }));
  };
  var emailPopupModal = showEmailPopup ? JsxRuntime.jsx(EmailSenderPopUp$ReactHooksTemplate.make, {
          isOpen: showEmailPopup,
          onClose: (function (param) {
              Curry._1(setShowEmailPopup, (function (param) {
                      return false;
                    }));
              Curry._1(setNewEmailFromId, (function (param) {
                      return EmailFromId$ReactHooksTemplate.empty();
                    }));
            }),
          selectedFromId: newEmailFromId,
          onUpdateEmail: handleEmailInputChange,
          onSubmit: (function (param) {
              var value = EmailFromId$ReactHooksTemplate.fromId(newEmailFromId);
              var params = {};
              var encodedEmail = Json_encode.object_({
                    hd: [
                      "from_id",
                      value
                    ],
                    tl: {
                      hd: [
                        "default",
                        false
                      ],
                      tl: /* [] */0
                    }
                  });
              params["email_from_ids"] = encodedEmail;
              Curry._1(setShowEmailPopup, (function (param) {
                      return false;
                    }));
              Curry._1(setNewEmailFromId, (function (param) {
                      return EmailFromId$ReactHooksTemplate.empty();
                    }));
              Js_promise.then_((function (response) {
                      var status = Json_decode.field("status", (function (param) {
                              return Json_decode.withDefault("failed", Json_decode.string, param);
                            }), response);
                      if (status === "success") {
                        var newEmailId = Json_decode.field("email_from_ids", EmailFromId$ReactHooksTemplate.decode, response);
                        Curry._1(setEmailFromIds, (function (prev) {
                                return {
                                        hd: newEmailId,
                                        tl: prev
                                      };
                              }));
                        return Promise.resolve();
                      }
                      console.log("Failed to create email");
                      return Promise.resolve();
                    }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/email_from_ids", params));
            }),
          isDisabled: EmailFromId$ReactHooksTemplate.fromId(newEmailFromId) === "",
          existingEmails: emailFromIds
        }) : null;
  var fetchCampaign = function (param) {
    var url = "/api/v1/campaigns/" + campaignId + "/follow_up_survey";
    Js_promise.then_((function (json) {
            var status = Json_decode.field("status", Json_decode.string, json);
            if (status === "success") {
              var campaignData = Json_decode.field("campaign", Campaign$ReactHooksTemplate.decode, json);
              var followUpConditions = Json_decode.field("campaign", (function (param) {
                      return Json_decode.field("follow_up_conditions", (function (param) {
                                    return Json_decode.list((function (json) {
                                                  return LogicCondition$ReactHooksTemplate.decode(json, /* [] */0, state.dataFields);
                                                }), param);
                                  }), param);
                    }), json);
              var updatedCampaign = Campaign$ReactHooksTemplate.setFollowUpConditions(campaignData, followUpConditions);
              var followUpModes = Belt_List.map(Campaign$ReactHooksTemplate.followUpModes(campaignData), (function (x) {
                      return {
                              TAG: "Valid",
                              _0: Mode$ReactHooksTemplate.toForm(x)
                            };
                    }));
              var frequencyType = Campaign$ReactHooksTemplate.sendingFrequency(campaignData) % 24 === 0 ? "Day" : "Hour";
              Curry._1(setState, (function (state) {
                      return {
                              campaign: updatedCampaign,
                              edited: state.edited,
                              sendingFrequencyType: frequencyType,
                              notification: state.notification,
                              enabled: Campaign$ReactHooksTemplate.followUpEnabled(campaignData),
                              followUpModes: followUpModes,
                              deletedFollowUpModes: state.deletedFollowUpModes,
                              availableModes: state.availableModes,
                              followUpConditions: followUpConditions,
                              deletedFollowUpConditions: state.deletedFollowUpConditions,
                              dataFields: state.dataFields
                            };
                    }));
            } else {
              Curry._1(setState, (function (state) {
                      return state;
                    }));
            }
            return Promise.resolve();
          }), Http$ReactHooksTemplate.fetchGetJSON(url));
  };
  var fetchEmailSenderIds = function (param) {
    Js_promise.then_((function (json) {
            return Promise.resolve(Curry._1(setEmailFromIds, (function (param) {
                              return Json_decode.field("email_from_ids", (function (param) {
                                            return Json_decode.list(EmailFromId$ReactHooksTemplate.decode, param);
                                          }), json);
                            })));
          }), Js_promise.then_((function (json) {
                return Fetch.$$Response.json(json);
              }), fetch("/api/v1/email_from_ids")));
  };
  var fetchSenderIds = function (param) {
    Js_promise.then_((function (json) {
            return Promise.resolve(Curry._1(setSenderIds, (function (param) {
                              return Json_decode.field("sms_sender_ids", (function (param) {
                                            return Json_decode.list(SmsSenderId$ReactHooksTemplate.decode, param);
                                          }), json);
                            })));
          }), Js_promise.then_((function (json) {
                return Fetch.$$Response.json(json);
              }), fetch("/api/v1/sms_sender_ids")));
  };
  var fetchWhatsappApiConfigurations = function (param) {
    Js_promise.$$catch((function (_error) {
            return Promise.resolve();
          }), Js_promise.then_((function (apis) {
                Curry._1(setWhatsappApiConfigurations, (function (param) {
                        return apis;
                      }));
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/api_configurations?api_type=whatsapp", ApiConfiguration$ReactHooksTemplate.decodeList)));
  };
  var fetchEmailTemplates = function (param) {
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Curry._1(setEmailTemplates, (function (param) {
                                    return Json_decode.field("email_templates", (function (param) {
                                                  return Json_decode.list(EmailTemplate$ReactHooksTemplate.decode, param);
                                                }), json);
                                  })));
                }), Js_promise.then_((function (json) {
                      return Fetch.$$Response.json(json);
                    }), fetch("/api/v1/email_templates")));
  };
  var fetchDataFields = function (param) {
    Js_promise.then_((function (dataFields) {
            return Promise.resolve(Curry._1(setState, (function (state) {
                              return {
                                      campaign: state.campaign,
                                      edited: state.edited,
                                      sendingFrequencyType: state.sendingFrequencyType,
                                      notification: state.notification,
                                      enabled: state.enabled,
                                      followUpModes: state.followUpModes,
                                      deletedFollowUpModes: state.deletedFollowUpModes,
                                      availableModes: state.availableModes,
                                      followUpConditions: state.followUpConditions,
                                      deletedFollowUpConditions: state.deletedFollowUpConditions,
                                      dataFields: dataFields
                                    };
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/data_fields?paginate=false", (function (param) {
                return Json_decode.field("data_fields", (function (param) {
                              return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
                            }), param);
              })));
  };
  React.useEffect((function (param) {
          fetchEmailSenderIds();
          fetchSenderIds();
          fetchWhatsappApiConfigurations();
          fetchEmailTemplates();
          fetchDataFields();
        }), []);
  React.useEffect((function (param) {
          fetchCampaign();
        }), [state.dataFields]);
  var campaignModes = List.flatten(Belt_List.map(List.flatten(Belt_List.map(Campaign$ReactHooksTemplate.applicationSettings(state.campaign), (function (x) {
                      var y = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
                      if (y.TAG === "CampaignModes") {
                        return CampaignModes$ReactHooksTemplate.value(y._0);
                      } else {
                        return /* [] */0;
                      }
                    }))), (function (y) {
              return Belt_List.keep(state.availableModes, (function (x) {
                            return Mode$ReactHooksTemplate.modeType(x) === y;
                          }));
            })));
  var hasFollowUpMode = function (modeType) {
    return Belt_List.getBy(state.followUpModes, (function (x) {
                  var modeForm = FormField$ReactHooksTemplate.getInputValue(x);
                  return modeType === Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(modeForm));
                })) !== undefined;
  };
  var getFollowUpMode = function (modeType) {
    return Belt_List.getBy(state.followUpModes, (function (x) {
                  var mode = FormField$ReactHooksTemplate.getInputValue(x);
                  return modeType === Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(mode));
                }));
  };
  var addFollowUpMode = function (modeType) {
    var mode;
    switch (modeType) {
      case "AnonymousLink" :
          mode = {
            TAG: "Valid",
            _0: {
              id: undefined,
              formMode: {
                TAG: "AnonymousLink",
                _0: AnonymousLinkMode$ReactHooksTemplate.toForm(AnonymousLinkMode$ReactHooksTemplate.empty())
              }
            }
          };
          break;
      case "AppLink" :
          mode = {
            TAG: "Pristine",
            _0: {
              id: undefined,
              formMode: {
                TAG: "AppLink",
                _0: AppLinkMode$ReactHooksTemplate.toForm(AppLinkMode$ReactHooksTemplate.empty())
              }
            }
          };
          break;
      case "Email" :
          var emailTemplate = Belt_List.head(emailTempaltes);
          mode = {
            TAG: "Pristine",
            _0: {
              id: undefined,
              formMode: emailTemplate !== undefined ? ({
                    TAG: "Email",
                    _0: EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setEmailTemplateId(EmailTemplate$ReactHooksTemplate.id(Caml_option.valFromOption(emailTemplate)), EmailMode$ReactHooksTemplate.empty()))
                  }) : ({
                    TAG: "Email",
                    _0: EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.empty())
                  })
            }
          };
          break;
      case "Sms" :
          mode = {
            TAG: "Pristine",
            _0: {
              id: undefined,
              formMode: {
                TAG: "Sms",
                _0: SmsMode$ReactHooksTemplate.toForm(SmsMode$ReactHooksTemplate.empty())
              }
            }
          };
          break;
      case "SmsLink" :
          mode = {
            TAG: "Pristine",
            _0: {
              id: undefined,
              formMode: {
                TAG: "SmsLink",
                _0: SmsLinkMode$ReactHooksTemplate.toForm(SmsLinkMode$ReactHooksTemplate.empty())
              }
            }
          };
          break;
      case "Telephonic" :
          mode = {
            TAG: "Valid",
            _0: {
              id: undefined,
              formMode: "Telephonic"
            }
          };
          break;
      case "WebsiteLink" :
          mode = {
            TAG: "Pristine",
            _0: {
              id: undefined,
              formMode: {
                TAG: "WebsiteLink",
                _0: WebsiteLinkMode$ReactHooksTemplate.toForm(WebsiteLinkMode$ReactHooksTemplate.empty())
              }
            }
          };
          break;
      case "WhatsappLink" :
          var activeApis = Belt_List.keep(whatsappApiConfigurations, (function (api) {
                  return api.isActive;
                }));
          var initialId = activeApis && !activeApis.tl ? activeApis.hd.id : undefined;
          mode = {
            TAG: "Pristine",
            _0: {
              id: undefined,
              formMode: {
                TAG: "WhatsappLink",
                _0: WhatsappLinkMode$ReactHooksTemplate.toForm(WhatsappLinkMode$ReactHooksTemplate.setApiConfigurationId(initialId, WhatsappLinkMode$ReactHooksTemplate.empty()))
              }
            }
          };
          break;
      default:
        mode = {
          TAG: "Pristine",
          _0: {
            id: undefined,
            formMode: {
              TAG: "Email",
              _0: EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.empty())
            }
          }
        };
    }
    Curry._1(setState, (function (state) {
            return {
                    campaign: state.campaign,
                    edited: true,
                    sendingFrequencyType: state.sendingFrequencyType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: {
                      hd: mode,
                      tl: state.followUpModes
                    },
                    deletedFollowUpModes: state.deletedFollowUpModes,
                    availableModes: state.availableModes,
                    followUpConditions: state.followUpConditions,
                    deletedFollowUpConditions: state.deletedFollowUpConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var removeFollowUpMode = function (modeType) {
    var updatedFollowUpModes = Belt_List.keep(state.followUpModes, (function (x) {
            var mode = FormField$ReactHooksTemplate.getInputValue(x);
            return modeType !== Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(mode));
          }));
    var deletedFollowUpModes = Belt_List.keep(state.followUpModes, (function (x) {
            var mode = FormField$ReactHooksTemplate.getInputValue(x);
            return modeType === Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(mode));
          }));
    Curry._1(setState, (function (state) {
            return {
                    campaign: state.campaign,
                    edited: true,
                    sendingFrequencyType: state.sendingFrequencyType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: updatedFollowUpModes,
                    deletedFollowUpModes: Belt_List.concat(state.deletedFollowUpModes, deletedFollowUpModes),
                    availableModes: state.availableModes,
                    followUpConditions: state.followUpConditions,
                    deletedFollowUpConditions: state.deletedFollowUpConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var updateFollowUpMode = function (modeType, updatedMode) {
    Curry._1(setState, (function (state) {
            return {
                    campaign: state.campaign,
                    edited: true,
                    sendingFrequencyType: state.sendingFrequencyType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: Belt_List.map(state.followUpModes, (function (x) {
                            var mode = FormField$ReactHooksTemplate.getInputValue(x);
                            if (modeType === Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(mode))) {
                              return {
                                      TAG: "Valid",
                                      _0: updatedMode
                                    };
                            } else {
                              return x;
                            }
                          })),
                    deletedFollowUpModes: state.deletedFollowUpModes,
                    availableModes: state.availableModes,
                    followUpConditions: state.followUpConditions,
                    deletedFollowUpConditions: state.deletedFollowUpConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var updateEmailMode = function (modeType, emailFormMode) {
    var modeField = getFollowUpMode(modeType);
    if (modeField === undefined) {
      return ;
    }
    var mode = FormField$ReactHooksTemplate.getInputValue(modeField);
    var updatedMode_id = mode.id;
    var updatedMode_formMode = {
      TAG: "Email",
      _0: emailFormMode
    };
    var updatedMode = {
      id: updatedMode_id,
      formMode: updatedMode_formMode
    };
    updateFollowUpMode(modeType, updatedMode);
  };
  var modeView = function (modeType) {
    var modeField = getFollowUpMode(modeType);
    if (modeField === undefined) {
      return null;
    }
    var mode = FormField$ReactHooksTemplate.getInputValue(modeField);
    var emailMode = mode.formMode;
    if (typeof emailMode !== "object") {
      return JsxRuntime.jsx("div", {
                  children: "No additional configuration needed for Telephonic mode.",
                  className: "border border-gray-300 mt-6 p-4 rounded-lg"
                });
    }
    switch (emailMode.TAG) {
      case "Email" :
          var emailMode$1 = emailMode._0;
          var emailFromIdOptions = Belt_List.map(emailFromIds, EmailFromId$ReactHooksTemplate.fromId);
          var id = EmailMode$ReactHooksTemplate.fromId(EmailMode$ReactHooksTemplate.fromForm(emailMode$1));
          var selectedEmailFromId = id !== undefined ? Belt_Option.getWithDefault(Belt_Option.map(Belt_List.getBy(emailFromIds, (function (x) {
                            return Caml_obj.equal(EmailFromId$ReactHooksTemplate.id(x), id);
                          })), EmailFromId$ReactHooksTemplate.fromId), "") : "";
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(SelectBoxNew$ReactHooksTemplate.make, {
                                            label: "Select From address",
                                            value: selectedEmailFromId,
                                            handleChange: (function ($$event) {
                                                var selectedFromId = $$event.target.value;
                                                var id = Belt_Option.flatMap(Belt_List.getBy(emailFromIds, (function (x) {
                                                            return EmailFromId$ReactHooksTemplate.fromId(x) === selectedFromId;
                                                          })), EmailFromId$ReactHooksTemplate.id);
                                                if (id !== undefined) {
                                                  var updatedEmailMode = EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setEmailFromId(id, EmailMode$ReactHooksTemplate.fromForm(emailMode$1)));
                                                  return updateEmailMode(modeType, updatedEmailMode);
                                                }
                                                var updatedEmailMode$1 = EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setEmailFromId(undefined, EmailMode$ReactHooksTemplate.fromForm(emailMode$1)));
                                                updateEmailMode(modeType, updatedEmailMode$1);
                                              }),
                                            labelCSS: "text-sm font-medium text-gray-700 mb-2",
                                            className: "bg-white block border border-gray-300 px-3 py-2 rounded text-sm max-w-sm w-4/5",
                                            options: emailFromIdOptions
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("a", {
                                                  children: "+ Add New email address",
                                                  className: "cursor-pointer flex inline-block justify-end text-blue-600 text-xs",
                                                  onClick: (function (param) {
                                                      Curry._1(setShowEmailPopup, (function (prev) {
                                                              return !prev;
                                                            }));
                                                      Curry._1(setNewEmailFromId, (function (param) {
                                                              return EmailFromId$ReactHooksTemplate.empty();
                                                            }));
                                                    })
                                                }),
                                            className: "mt-2"
                                          })
                                    ],
                                    className: "p-4"
                                  }),
                              className: "mb-4"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                    label: "Subject",
                                                    value: FormField$ReactHooksTemplate.getInputValue(emailMode$1.subject),
                                                    handleChange: (function ($$event) {
                                                        var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                                        var updatedEmailMode = EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setSubject(value, EmailMode$ReactHooksTemplate.fromForm(emailMode$1)));
                                                        updateEmailMode(modeType, updatedEmailMode);
                                                      }),
                                                    maxLength: 100
                                                  }),
                                              validationErrors(emailMode$1.subject)
                                            ],
                                            className: "mb-8"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(TextAreaInputNew$ReactHooksTemplate.make, {
                                                    label: "Body",
                                                    value: FormField$ReactHooksTemplate.getInputValue(emailMode$1.body),
                                                    handleChange: (function ($$event) {
                                                        var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                                        var updatedEmailMode = EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setBody(value, EmailMode$ReactHooksTemplate.fromForm(emailMode$1)));
                                                        updateEmailMode(modeType, updatedEmailMode);
                                                      })
                                                  }),
                                              validationErrors(emailMode$1.body)
                                            ]
                                          })
                                    ],
                                    className: "p-6 bg-ghostwhite border border-gray-300 rounded-lg"
                                  }),
                              className: "mb-4"
                            })
                      ],
                      className: "border border-gray-300 mt-6 p-4 rounded-lg"
                    });
      case "Sms" :
          var smsMode = emailMode._0;
          return JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("label", {
                                    children: "Sender ID",
                                    className: "block text-sm font-medium text-gray-700 mb-1"
                                  }),
                              JsxRuntime.jsxs("select", {
                                    children: [
                                      JsxRuntime.jsx("option", {
                                            children: "Select SenderId",
                                            value: "0"
                                          }),
                                      $$Array.of_list(Belt_List.map(senderIds, (function (x) {
                                                  return JsxRuntime.jsx("option", {
                                                              children: SmsSenderId$ReactHooksTemplate.senderId(x),
                                                              value: String(SmsSenderId$ReactHooksTemplate.id(x))
                                                            }, String(SmsSenderId$ReactHooksTemplate.id(x)));
                                                })))
                                    ],
                                    className: "w-full border rounded-lg px-3 py-2 text-sm",
                                    value: String(SmsMode$ReactHooksTemplate.senderId(SmsMode$ReactHooksTemplate.fromForm(smsMode))),
                                    onChange: (function ($$event) {
                                        var value = Caml_format.int_of_string(Utils$ReactHooksTemplate.formTargetValue($$event));
                                        var updatedSmsMode = SmsMode$ReactHooksTemplate.toForm(SmsMode$ReactHooksTemplate.setSenderId(value, SmsMode$ReactHooksTemplate.fromForm(smsMode)));
                                        var modeField = getFollowUpMode(modeType);
                                        if (modeField === undefined) {
                                          return ;
                                        }
                                        var mode = FormField$ReactHooksTemplate.getInputValue(modeField);
                                        var updatedMode_id = mode.id;
                                        var updatedMode_formMode = {
                                          TAG: "Sms",
                                          _0: updatedSmsMode
                                        };
                                        var updatedMode = {
                                          id: updatedMode_id,
                                          formMode: updatedMode_formMode
                                        };
                                        updateFollowUpMode(modeType, updatedMode);
                                      })
                                  })
                            ]
                          }),
                      className: "bg-ghostwhite border border-gray-300 mt-6 p-4 rounded-lg"
                    });
      case "SmsLink" :
          var smsLinkMode = emailMode._0;
          return JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(TextAreaInputNew$ReactHooksTemplate.make, {
                                    label: "Message",
                                    value: FormField$ReactHooksTemplate.getInputValue(smsLinkMode.message),
                                    handleChange: (function ($$event) {
                                        var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                        var updatedSmsLinkMode = SmsLinkMode$ReactHooksTemplate.toForm(SmsLinkMode$ReactHooksTemplate.setMessage(value, SmsLinkMode$ReactHooksTemplate.fromForm(smsLinkMode)));
                                        var modeField = getFollowUpMode(modeType);
                                        if (modeField === undefined) {
                                          return ;
                                        }
                                        var mode = FormField$ReactHooksTemplate.getInputValue(modeField);
                                        var updatedMode_id = mode.id;
                                        var updatedMode_formMode = {
                                          TAG: "SmsLink",
                                          _0: updatedSmsLinkMode
                                        };
                                        var updatedMode = {
                                          id: updatedMode_id,
                                          formMode: updatedMode_formMode
                                        };
                                        updateFollowUpMode(modeType, updatedMode);
                                      })
                                  }),
                              validationErrors(smsLinkMode.message)
                            ]
                          }),
                      className: "bg-ghostwhite border border-gray-300 mt-6 p-4 rounded-lg pb-8"
                    });
      case "WhatsappLink" :
          var whatsappLinkMode = emailMode._0;
          var boundId = WhatsappLinkMode$ReactHooksTemplate.apiConfigurationId(WhatsappLinkMode$ReactHooksTemplate.fromForm(whatsappLinkMode));
          var selectableApis = Belt_List.keep(whatsappApiConfigurations, (function (api) {
                  if (api.isActive) {
                    return true;
                  } else {
                    return Caml_obj.equal(api.id, boundId);
                  }
                }));
          var selectedValue = boundId !== undefined ? String(boundId) : "0";
          return JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(JsxRuntime.Fragment, {
                            children: Caml_option.some(JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "WhatsApp API",
                                              className: "block text-sm font-medium mb-2"
                                            }),
                                        JsxRuntime.jsxs("select", {
                                              children: [
                                                JsxRuntime.jsx("option", {
                                                      children: "Select WhatsApp API",
                                                      value: "0"
                                                    }),
                                                $$Array.of_list(Belt_List.map(selectableApis, (function (api) {
                                                            var optionId = Belt_Option.getWithDefault(api.id, 0);
                                                            var label = api.isActive ? api.name : api.name + " (Inactive)";
                                                            return JsxRuntime.jsx("option", {
                                                                        children: label,
                                                                        value: String(optionId)
                                                                      }, String(optionId));
                                                          })))
                                              ],
                                              className: "w-full border rounded-lg px-3 py-2 text-sm",
                                              value: selectedValue,
                                              onChange: (function ($$event) {
                                                  var raw = Caml_format.int_of_string(Utils$ReactHooksTemplate.formTargetValue($$event));
                                                  var id = raw === 0 ? undefined : raw;
                                                  var updatedWhatsappLinkMode = WhatsappLinkMode$ReactHooksTemplate.toForm(WhatsappLinkMode$ReactHooksTemplate.setApiConfigurationId(id, WhatsappLinkMode$ReactHooksTemplate.fromForm(whatsappLinkMode)));
                                                  var modeField = getFollowUpMode(modeType);
                                                  if (modeField === undefined) {
                                                    return ;
                                                  }
                                                  var mode = FormField$ReactHooksTemplate.getInputValue(modeField);
                                                  var updatedMode_id = mode.id;
                                                  var updatedMode_formMode = {
                                                    TAG: "WhatsappLink",
                                                    _0: updatedWhatsappLinkMode
                                                  };
                                                  var updatedMode = {
                                                    id: updatedMode_id,
                                                    formMode: updatedMode_formMode
                                                  };
                                                  updateFollowUpMode(modeType, updatedMode);
                                                })
                                            }),
                                        validationErrors(whatsappLinkMode.apiConfigurationId),
                                        Belt_List.length(selectableApis) === 0 ? JsxRuntime.jsx("p", {
                                                children: "No WhatsApp API configurations available. Add one under General Settings.",
                                                className: "text-sm text-firebrick mt-2"
                                              }) : null
                                      ],
                                      className: "mb-4"
                                    }))
                          }),
                      className: "bg-ghostwhite border border-gray-300 mt-6 p-4 rounded-lg pb-8 "
                    });
      case "AppLink" :
          var appLinkMode = emailMode._0;
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(TextAreaInputNew$ReactHooksTemplate.make, {
                              label: "Message",
                              value: FormField$ReactHooksTemplate.getInputValue(appLinkMode.message),
                              handleChange: (function ($$event) {
                                  var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                  var updatedAppLinkMode = AppLinkMode$ReactHooksTemplate.toForm(AppLinkMode$ReactHooksTemplate.setMessage(value, AppLinkMode$ReactHooksTemplate.fromForm(appLinkMode)));
                                  var modeField = getFollowUpMode(modeType);
                                  if (modeField === undefined) {
                                    return ;
                                  }
                                  var mode = FormField$ReactHooksTemplate.getInputValue(modeField);
                                  var updatedMode_id = mode.id;
                                  var updatedMode_formMode = {
                                    TAG: "AppLink",
                                    _0: updatedAppLinkMode
                                  };
                                  var updatedMode = {
                                    id: updatedMode_id,
                                    formMode: updatedMode_formMode
                                  };
                                  updateFollowUpMode(modeType, updatedMode);
                                })
                            }),
                        validationErrors(appLinkMode.message)
                      ],
                      className: "bg-ghostwhite border border-gray-300 mt-6 p-4 rounded-lg pb-8"
                    });
      case "WebsiteLink" :
          var websiteLinkMode = emailMode._0;
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(TextAreaInputNew$ReactHooksTemplate.make, {
                              label: "Message",
                              value: FormField$ReactHooksTemplate.getInputValue(websiteLinkMode.message),
                              handleChange: (function ($$event) {
                                  var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                  var updatedWebsiteLinkMode = WebsiteLinkMode$ReactHooksTemplate.toForm(WebsiteLinkMode$ReactHooksTemplate.setMessage(value, WebsiteLinkMode$ReactHooksTemplate.fromForm(websiteLinkMode)));
                                  var modeField = getFollowUpMode(modeType);
                                  if (modeField === undefined) {
                                    return ;
                                  }
                                  var mode = FormField$ReactHooksTemplate.getInputValue(modeField);
                                  var updatedMode_id = mode.id;
                                  var updatedMode_formMode = {
                                    TAG: "WebsiteLink",
                                    _0: updatedWebsiteLinkMode
                                  };
                                  var updatedMode = {
                                    id: updatedMode_id,
                                    formMode: updatedMode_formMode
                                  };
                                  updateFollowUpMode(modeType, updatedMode);
                                })
                            }),
                        validationErrors(websiteLinkMode.message)
                      ],
                      className: "bg-ghostwhite border border-gray-300 mt-6 p-4 rounded-lg pb-8"
                    });
      case "AnonymousLink" :
          return JsxRuntime.jsx("div", {
                      children: "No additional configuration needed for Anonymous Link.",
                      className: "border border-gray-300 mt-6 p-4 rounded-lg"
                    });
      
    }
  };
  var intervalInSettings = Moment.duration(Campaign$ReactHooksTemplate.sendingFrequency(state.campaign), "hours");
  var match$7 = state.sendingFrequencyType;
  var displayValue;
  displayValue = match$7 === "Day" ? intervalInSettings.asDays() : intervalInSettings.asHours();
  var getSurveyResponseWindow = function (campaign) {
    return Belt_Option.getWithDefault(Belt_List.head(Belt_List.keepMap(Campaign$ReactHooksTemplate.applicationSettings(campaign), (function (x) {
                          var y = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
                          if (y.TAG === "SurveyResponseWindow") {
                            return SurveyResponseWindow$ReactHooksTemplate.value(y._0);
                          }
                          
                        }))), 48);
  };
  var handleSendingFrequency = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    if (value === "") {
      var updatedCampaign = Campaign$ReactHooksTemplate.setSendingFrequency(state.campaign, 0);
      return Curry._1(setState, (function (state) {
                    return {
                            campaign: updatedCampaign,
                            edited: true,
                            sendingFrequencyType: state.sendingFrequencyType,
                            notification: state.notification,
                            enabled: state.enabled,
                            followUpModes: state.followUpModes,
                            deletedFollowUpModes: state.deletedFollowUpModes,
                            availableModes: state.availableModes,
                            followUpConditions: state.followUpConditions,
                            deletedFollowUpConditions: state.deletedFollowUpConditions,
                            dataFields: state.dataFields
                          };
                  }));
    }
    var intValue = Belt_Int.fromString(value);
    if (intValue === undefined) {
      return ;
    }
    var match = state.sendingFrequencyType;
    var interval;
    interval = match === "Day" ? "days" : "hours";
    var frequencyInHours = Moment.duration(intValue, interval).asHours() | 0;
    var responseWindow = getSurveyResponseWindow(state.campaign);
    var currentLimit = Campaign$ReactHooksTemplate.sendingLimit(state.campaign);
    if (frequencyInHours > responseWindow) {
      return Curry._1(setState, (function (state) {
                    return {
                            campaign: state.campaign,
                            edited: state.edited,
                            sendingFrequencyType: state.sendingFrequencyType,
                            notification: {
                              TAG: "Failure",
                              _0: "Sending frequency cannot exceed survey response window of " + String(responseWindow) + " hours"
                            },
                            enabled: state.enabled,
                            followUpModes: state.followUpModes,
                            deletedFollowUpModes: state.deletedFollowUpModes,
                            availableModes: state.availableModes,
                            followUpConditions: state.followUpConditions,
                            deletedFollowUpConditions: state.deletedFollowUpConditions,
                            dataFields: state.dataFields
                          };
                  }));
    }
    if (currentLimit > 0 && frequencyInHours > 0) {
      var followupTime = currentLimit * frequencyInHours;
      if (followupTime > responseWindow) {
        var maxAllowedFrequency = Caml_int32.div(responseWindow, currentLimit);
        Caml_int32.div(responseWindow, frequencyInHours);
        return Curry._1(setState, (function (state) {
                      return {
                              campaign: state.campaign,
                              edited: state.edited,
                              sendingFrequencyType: state.sendingFrequencyType,
                              notification: {
                                TAG: "Failure",
                                _0: "Selected frequency is too high for " + String(currentLimit) + " follow-ups. Max allowed: " + String(maxAllowedFrequency) + " hours."
                              },
                              enabled: state.enabled,
                              followUpModes: state.followUpModes,
                              deletedFollowUpModes: state.deletedFollowUpModes,
                              availableModes: state.availableModes,
                              followUpConditions: state.followUpConditions,
                              deletedFollowUpConditions: state.deletedFollowUpConditions,
                              dataFields: state.dataFields
                            };
                    }));
      }
      var updatedCampaign$1 = Campaign$ReactHooksTemplate.setSendingFrequency(state.campaign, frequencyInHours);
      return Curry._1(setState, (function (state) {
                    return {
                            campaign: updatedCampaign$1,
                            edited: true,
                            sendingFrequencyType: state.sendingFrequencyType,
                            notification: state.notification,
                            enabled: state.enabled,
                            followUpModes: state.followUpModes,
                            deletedFollowUpModes: state.deletedFollowUpModes,
                            availableModes: state.availableModes,
                            followUpConditions: state.followUpConditions,
                            deletedFollowUpConditions: state.deletedFollowUpConditions,
                            dataFields: state.dataFields
                          };
                  }));
    }
    var updatedCampaign$2 = Campaign$ReactHooksTemplate.setSendingFrequency(state.campaign, frequencyInHours);
    Curry._1(setState, (function (state) {
            return {
                    campaign: updatedCampaign$2,
                    edited: true,
                    sendingFrequencyType: state.sendingFrequencyType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: state.followUpModes,
                    deletedFollowUpModes: state.deletedFollowUpModes,
                    availableModes: state.availableModes,
                    followUpConditions: state.followUpConditions,
                    deletedFollowUpConditions: state.deletedFollowUpConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var handleSendingLimit = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    if (value === "") {
      var updatedCampaign = Campaign$ReactHooksTemplate.setSendingLimit(state.campaign, 0);
      return Curry._1(setState, (function (state) {
                    return {
                            campaign: updatedCampaign,
                            edited: true,
                            sendingFrequencyType: state.sendingFrequencyType,
                            notification: state.notification,
                            enabled: state.enabled,
                            followUpModes: state.followUpModes,
                            deletedFollowUpModes: state.deletedFollowUpModes,
                            availableModes: state.availableModes,
                            followUpConditions: state.followUpConditions,
                            deletedFollowUpConditions: state.deletedFollowUpConditions,
                            dataFields: state.dataFields
                          };
                  }));
    }
    var limit = Belt_Int.fromString(value);
    if (limit === undefined) {
      return ;
    }
    var frequency = Campaign$ReactHooksTemplate.sendingFrequency(state.campaign);
    var responseWindow = getSurveyResponseWindow(state.campaign);
    if (frequency === 0) {
      var updatedCampaign$1 = Campaign$ReactHooksTemplate.setSendingLimit(state.campaign, limit);
      return Curry._1(setState, (function (state) {
                    return {
                            campaign: updatedCampaign$1,
                            edited: true,
                            sendingFrequencyType: state.sendingFrequencyType,
                            notification: state.notification,
                            enabled: state.enabled,
                            followUpModes: state.followUpModes,
                            deletedFollowUpModes: state.deletedFollowUpModes,
                            availableModes: state.availableModes,
                            followUpConditions: state.followUpConditions,
                            deletedFollowUpConditions: state.deletedFollowUpConditions,
                            dataFields: state.dataFields
                          };
                  }));
    }
    var allowedLimit = Caml_int32.div(responseWindow, frequency);
    if (limit > allowedLimit) {
      return Curry._1(setState, (function (state) {
                    return {
                            campaign: state.campaign,
                            edited: state.edited,
                            sendingFrequencyType: state.sendingFrequencyType,
                            notification: {
                              TAG: "Failure",
                              _0: "Follow-ups exceed the response window. Max allowed: " + String(allowedLimit)
                            },
                            enabled: state.enabled,
                            followUpModes: state.followUpModes,
                            deletedFollowUpModes: state.deletedFollowUpModes,
                            availableModes: state.availableModes,
                            followUpConditions: state.followUpConditions,
                            deletedFollowUpConditions: state.deletedFollowUpConditions,
                            dataFields: state.dataFields
                          };
                  }));
    }
    var updatedCampaign$2 = Campaign$ReactHooksTemplate.setSendingLimit(state.campaign, limit);
    Curry._1(setState, (function (state) {
            return {
                    campaign: updatedCampaign$2,
                    edited: true,
                    sendingFrequencyType: state.sendingFrequencyType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: state.followUpModes,
                    deletedFollowUpModes: state.deletedFollowUpModes,
                    availableModes: state.availableModes,
                    followUpConditions: state.followUpConditions,
                    deletedFollowUpConditions: state.deletedFollowUpConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var handleIntervalTypeChange = function ($$event) {
    var value = $$event.target.value;
    var newType;
    switch (value) {
      case "days" :
          newType = "Day";
          break;
      default:
        newType = "Hour";
    }
    Curry._1(setState, (function (state) {
            return {
                    campaign: state.campaign,
                    edited: true,
                    sendingFrequencyType: newType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: state.followUpModes,
                    deletedFollowUpModes: state.deletedFollowUpModes,
                    availableModes: state.availableModes,
                    followUpConditions: state.followUpConditions,
                    deletedFollowUpConditions: state.deletedFollowUpConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var buildTargetDict = function (param) {
    var followUpModeAttributes = Belt_List.toArray(Belt_List.concat(Belt_List.map(state.followUpModes, (function (modeField) {
                    var modeForm = FormField$ReactHooksTemplate.getInputValue(modeField);
                    var mode = Mode$ReactHooksTemplate.fromForm(modeForm);
                    return Mode$ReactHooksTemplate.encoder(false, mode);
                  })), Belt_List.map(state.deletedFollowUpModes, (function (modeField) {
                    var mode = Mode$ReactHooksTemplate.fromForm(FormField$ReactHooksTemplate.getInputValue(modeField));
                    return Mode$ReactHooksTemplate.encoder(true, mode);
                  }))));
    var followUpConditionsAttributes = Belt_List.toArray(Belt_List.concat(Belt_List.map(state.followUpConditions, (function (condition) {
                    return LogicCondition$ReactHooksTemplate.toJson(false, condition);
                  })), Belt_List.map(state.deletedFollowUpConditions, (function (condition) {
                    return LogicCondition$ReactHooksTemplate.toJson(true, condition);
                  }))));
    var campaignObject = Json_encode.object_({
          hd: [
            "follow_up_enabled",
            state.enabled
          ],
          tl: {
            hd: [
              "sending_limit",
              Campaign$ReactHooksTemplate.sendingLimit(state.campaign)
            ],
            tl: {
              hd: [
                "sending_frequency",
                Campaign$ReactHooksTemplate.sendingFrequency(state.campaign)
              ],
              tl: {
                hd: [
                  "follow_up_campaign_modes_attributes",
                  followUpModeAttributes
                ],
                tl: {
                  hd: [
                    "follow_up_conditions_attributes",
                    followUpConditionsAttributes
                  ],
                  tl: /* [] */0
                }
              }
            }
          }
        });
    var params = {};
    params["campaign"] = campaignObject;
    return params;
  };
  var lhsOptions = Belt_List.map(state.dataFields, (function (df) {
          return {
                  TAG: "DataField",
                  _0: df
                };
        }));
  var addCondition = function (param) {
    var df = Belt_List.head(state.dataFields);
    var newCondition = df !== undefined ? LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
            TAG: "DataField",
            _0: Caml_option.valFromOption(df)
          }) : LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
            TAG: "DataField",
            _0: DataField$ReactHooksTemplate.empty()
          });
    Curry._1(setState, (function (state) {
            return {
                    campaign: state.campaign,
                    edited: true,
                    sendingFrequencyType: state.sendingFrequencyType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: state.followUpModes,
                    deletedFollowUpModes: state.deletedFollowUpModes,
                    availableModes: state.availableModes,
                    followUpConditions: Belt_List.add(state.followUpConditions, newCondition),
                    deletedFollowUpConditions: state.deletedFollowUpConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var removeCondition = function (index) {
    Curry._1(setState, (function (state) {
            var conditionToRemove = Belt_List.get(state.followUpConditions, index);
            var updatedConditions = Belt_List.keepWithIndex(state.followUpConditions, (function (param, i) {
                    return i !== index;
                  }));
            var deletedConditions = conditionToRemove !== undefined ? ({
                  hd: conditionToRemove,
                  tl: state.deletedFollowUpConditions
                }) : state.deletedFollowUpConditions;
            return {
                    campaign: state.campaign,
                    edited: true,
                    sendingFrequencyType: state.sendingFrequencyType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: state.followUpModes,
                    deletedFollowUpModes: state.deletedFollowUpModes,
                    availableModes: state.availableModes,
                    followUpConditions: updatedConditions,
                    deletedFollowUpConditions: deletedConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var updateCondition = function (index, updatedCondition) {
    Curry._1(setState, (function (state) {
            var updatedConditions = Belt_List.mapWithIndex(state.followUpConditions, (function (i, condition) {
                    if (i === index) {
                      return updatedCondition;
                    } else {
                      return condition;
                    }
                  }));
            return {
                    campaign: state.campaign,
                    edited: true,
                    sendingFrequencyType: state.sendingFrequencyType,
                    notification: state.notification,
                    enabled: state.enabled,
                    followUpModes: state.followUpModes,
                    deletedFollowUpModes: state.deletedFollowUpModes,
                    availableModes: state.availableModes,
                    followUpConditions: updatedConditions,
                    deletedFollowUpConditions: state.deletedFollowUpConditions,
                    dataFields: state.dataFields
                  };
          }));
  };
  var alertType = state.notification;
  var disabled = state.enabled && (Belt_List.length(state.followUpModes) === 0 || Campaign$ReactHooksTemplate.sendingFrequency(state.campaign) === 0 || Campaign$ReactHooksTemplate.sendingLimit(state.campaign) === 0);
  var tmp;
  if (state.enabled) {
    var match$8 = state.sendingFrequencyType;
    var tmp$1;
    tmp$1 = match$8 === "Day" ? "Day" : "Hour";
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(FollowUpSendingRule$ReactHooksTemplate.make, {
                        campaign: state.campaign,
                        handleSendingLimit: handleSendingLimit,
                        fieldValidation: fieldValidation,
                        displayValue: displayValue,
                        handleSendingFrequency: handleSendingFrequency,
                        sendingFrequencyType: tmp$1,
                        handleIntervalTypeChange: handleIntervalTypeChange
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(FollowUpSurveyConditions$ReactHooksTemplate.make, {
                                followUpConditions: state.followUpConditions,
                                addCondition: addCondition,
                                lhsOptions: lhsOptions,
                                updateCondition: updateCondition,
                                removeCondition: removeCondition
                              }),
                          JsxRuntime.jsx(FollowUpSurveyMode$ReactHooksTemplate.make, {
                                campaignModes: campaignModes,
                                hasFollowUpMode: hasFollowUpMode,
                                addFollowUpMode: addFollowUpMode,
                                removeFollowUpMode: removeFollowUpMode,
                                modeView: modeView
                              })
                        ]
                      })
                ],
                className: "p-6 space-y-6"
              }),
          className: "border border-gray-300 rounded-lg bg-white w-3/5"
        });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                                    alertType: alertType,
                                    handleClose: (function (param) {
                                        Curry._1(setState, (function (state) {
                                                return {
                                                        campaign: state.campaign,
                                                        edited: state.edited,
                                                        sendingFrequencyType: state.sendingFrequencyType,
                                                        notification: undefined,
                                                        enabled: state.enabled,
                                                        followUpModes: state.followUpModes,
                                                        deletedFollowUpModes: state.deletedFollowUpModes,
                                                        availableModes: state.availableModes,
                                                        followUpConditions: state.followUpConditions,
                                                        deletedFollowUpConditions: state.deletedFollowUpConditions,
                                                        dataFields: state.dataFields
                                                      };
                                              }));
                                      })
                                  }),
                              className: "max-w-7xl mx-auto px-6 sm:px-8 py-4"
                            }),
                        className: "fixed top-0 left-0 right-0 z-50"
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("h2", {
                                              children: "Follow Up Survey",
                                              className: "text-lg font-semibold"
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: "Save",
                                              className: state.edited && !disabled ? "bg-pigmentblue hover:bg-cetaceanblue px-6 py-2 rounded text-sm text-white font-normal" : "bg-pigmentblue hover:bg-cetaceanblue px-6 py-2 rounded text-sm text-white font-normal disabled-input",
                                              disabled: disabled,
                                              onClick: (function (param) {
                                                  var url = "/api/v1/campaigns/" + campaignId + "/follow_up_survey";
                                                  Js_promise.then_((function (response) {
                                                          var status = Json_decode.field("status", (function (param) {
                                                                  return Json_decode.withDefault("failed", Json_decode.string, param);
                                                                }), response);
                                                          if (status === "success") {
                                                            Curry._1(setState, (function (state) {
                                                                    return {
                                                                            campaign: state.campaign,
                                                                            edited: true,
                                                                            sendingFrequencyType: state.sendingFrequencyType,
                                                                            notification: {
                                                                              TAG: "Success",
                                                                              _0: "Updated follow up survey successfully"
                                                                            },
                                                                            enabled: state.enabled,
                                                                            followUpModes: state.followUpModes,
                                                                            deletedFollowUpModes: state.deletedFollowUpModes,
                                                                            availableModes: state.availableModes,
                                                                            followUpConditions: state.followUpConditions,
                                                                            deletedFollowUpConditions: state.deletedFollowUpConditions,
                                                                            dataFields: state.dataFields
                                                                          };
                                                                  }));
                                                          } else {
                                                            Curry._1(setState, (function (state) {
                                                                    return {
                                                                            campaign: state.campaign,
                                                                            edited: false,
                                                                            sendingFrequencyType: state.sendingFrequencyType,
                                                                            notification: {
                                                                              TAG: "Failure",
                                                                              _0: "failed to update follow up survey"
                                                                            },
                                                                            enabled: state.enabled,
                                                                            followUpModes: state.followUpModes,
                                                                            deletedFollowUpModes: state.deletedFollowUpModes,
                                                                            availableModes: state.availableModes,
                                                                            followUpConditions: state.followUpConditions,
                                                                            deletedFollowUpConditions: state.deletedFollowUpConditions,
                                                                            dataFields: state.dataFields
                                                                          };
                                                                  }));
                                                          }
                                                          return Promise.resolve();
                                                        }), Http$ReactHooksTemplate.fetchPostJSON(url + "/update", buildTargetDict()));
                                                })
                                            })
                                      ],
                                      className: "flex justify-between items-center"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("span", {
                                                          children: "Enable Follow Up survey",
                                                          className: "text-sm font-medium text-gray-700"
                                                        }),
                                                    className: "flex-1"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                          checked: state.enabled,
                                                          handleChange: (function (param) {
                                                              var currentEnabled = state.enabled;
                                                              if (currentEnabled) {
                                                                return Curry._1(setState, (function (state) {
                                                                              var deletedModes = Belt_List.concat(state.followUpModes, state.deletedFollowUpModes);
                                                                              var deletedConditions = Belt_List.concat(state.followUpConditions, state.deletedFollowUpConditions);
                                                                              return {
                                                                                      campaign: Campaign$ReactHooksTemplate.setSendingLimit(Campaign$ReactHooksTemplate.setSendingFrequency(Campaign$ReactHooksTemplate.setFollowupEnabled(state.campaign, false), 0), 0),
                                                                                      edited: true,
                                                                                      sendingFrequencyType: state.sendingFrequencyType,
                                                                                      notification: state.notification,
                                                                                      enabled: false,
                                                                                      followUpModes: /* [] */0,
                                                                                      deletedFollowUpModes: deletedModes,
                                                                                      availableModes: state.availableModes,
                                                                                      followUpConditions: /* [] */0,
                                                                                      deletedFollowUpConditions: deletedConditions,
                                                                                      dataFields: state.dataFields
                                                                                    };
                                                                            }));
                                                              } else {
                                                                return Curry._1(setState, (function (state) {
                                                                              return {
                                                                                      campaign: Campaign$ReactHooksTemplate.setFollowupEnabled(state.campaign, true),
                                                                                      edited: true,
                                                                                      sendingFrequencyType: state.sendingFrequencyType,
                                                                                      notification: state.notification,
                                                                                      enabled: true,
                                                                                      followUpModes: state.followUpModes,
                                                                                      deletedFollowUpModes: state.deletedFollowUpModes,
                                                                                      availableModes: state.availableModes,
                                                                                      followUpConditions: state.followUpConditions,
                                                                                      deletedFollowUpConditions: state.deletedFollowUpConditions,
                                                                                      dataFields: state.dataFields
                                                                                    };
                                                                            }));
                                                              }
                                                            }),
                                                          labelClassName: "flex items-center"
                                                        }),
                                                    className: "ml-4"
                                                  })
                                            ],
                                            className: "flex items-center justify-between"
                                          }),
                                      className: "w-1/5"
                                    }),
                                tmp
                              ],
                              className: "space-y-6 h-full"
                            }),
                        emailPopupModal
                      ],
                      className: "p-6"
                    })
              ]
            });
}

var make = FollowUpSurvey;

exports.initialState = initialState;
exports.make = make;
/* initialState Not a pure module */
